import { render, staticRenderFns } from "./ConfigGraduateCurriculumFeeDeleteDialog.vue?vue&type=template&id=1fb1323a"
import script from "./ConfigGraduateCurriculumFeeDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfigGraduateCurriculumFeeDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports